<template>
    <div id="versionFooter"  :style="`background-color: ${this.footerColor}`">
        <div class="text-center">
            <a :href="hashLink" id="gitlink" target="_blank">Git Hash: {{ hash }}</a>
            <br>
            Build date: {{ bd }} - {{ $i18n.locale }}   
            <h1 v-if="!isConnected" id="connectionStatus"><i class="fas fa-exclamation-triangle"></i> Connection Lost <i class="fas fa-exclamation-triangle"></i></h1>
        </div>
    </div>
</template>


<script>
import GitHash from "@/assets/hash.json";
import BuildDate from "@/assets/buildDate.json";
import { setInterval } from 'timers';
export default {
    name: 'VersionFooter',
    computed: {
        hashLink: function() {
            return this.baseUrl + this.hash;
        },
        footerColor: function() {
            let color = process.env.VUE_APP_COLOR;

            return color === undefined ? "#000000" : color;
        }
    },
    methods: {
        checkConnection: function() {
            this.$http.get(`http://localhost:8080/sockjs-node/info`)
            .then(res => {
                this.isConnected = true;
            }).catch(err => {
                this.isConnected = false;
            })
        }
    },
    mounted() {
        // if (process.env.NODE_ENV !== 'production') {
        //     const that = this;
        //     this.intervalId = setInterval(function() {
        //         that.checkConnection();
        //     }, 1000);
        // }
        
    },
    beforeDestroy() {
        if (this.intervalId !== undefined) {
            clearInterval(this.intervalId);
        }
    },
    data() {
        return {
            hash: GitHash,
            bd: BuildDate,
            isConnected: true,
            intervalId: undefined,
            baseUrl: "https://gitlab.com/Casafile/casafile-frontend/commit/"
        }
    }
}
</script>

<style scoped lang="scss">
    #versionFooter {
        // position: fixed;
        // bottom: 0;
        // left: 0;
        width: 100%;
        margin: 0;
        padding: 10px;
        z-index: 10001;
        color: white;
    }


    #gitlink {
        text-decoration: none;
        color: white;
    }

    #connectionStatus {
        color: white !important;
        margin: 0;
        font-size: 5em;
        padding: 20px;
    }


    @media (max-width: 575.98px) { 
        #connectionStatus {
            font-size: 2.5em;
        }
    }

</style>